<template>
    <div>
        <headbar-block></headbar-block>
        <cta-block></cta-block>
        <section class="prices" id="o-co-hrajeme">
            <v-container>
                <v-row>
                    <v-col cols="14" offset="1" sm="16" offset-sm="0">
                        <h2 class="section-subtitle">O co hrajeme</h2>
                        <v-row>
                            <v-col cols="16" offset="0" sm="10" offset-sm="3">
                                <p class="prices__description">Je&nbsp;čas být zase spolu a&nbsp;kde&nbsp;jinde než v&nbsp;hospodě Staropramen
                                    u&nbsp;hezky načepovaného a&nbsp;oroseného piva!</p>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="14" offset="1" md="12" offset-md="2">
                        <div class="prices__boxes">
                            <div class="prices__box">
                                <div class="prices__content">
                                    <div class="prices__text">
                                        <div class="prices__icon">
                                            <img src="/img/index/smallicon.svg">
                                        </div>
                                        <p>Tři celkově nejlepší týmy
                                            vyhrají <span class="semibold">zážitkový den plný
                                            pravé smíchovské atmosféry</span>
                                            v&nbsp;pivovaru. Ve&nbsp;společnosti sládků
                                            poznáte pivovar Staropramen,
                                            naučíte se&nbsp;správně načepovat
                                            pivo, obdržíte originální věcné
                                            dárky, a&nbsp;navíc vás čeká skvělé
                                            pivo, jídlo a&nbsp;nezapomenutelná
                                            smíchovská zábava.</p>
                                    </div>
                                    <div class="prices__image">
                                        <img src="/img/index/price1.jpg">
                                    </div>
                                </div>
                            </div>
                            <div class="prices__box">
                                <div class="prices__content">
                                    <div class="prices__image">
                                        <img src="/img/index/price2.jpg">
                                    </div>
                                    <div class="prices__text">
                                        <div class="prices__icon">
                                            <img src="/img/index/smallicon.svg">
                                        </div>
                                        <p>Dalších sto celkově nejlepších týmů
                                        získá <span class="semibold">poukaz do&nbsp;hospody</span>
                                        v&nbsp;hodnotě 1&nbsp;000 Kč.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="prices__box">
                                <div class="prices__content">
                                    <div class="prices__text">
                                        <div class="prices__icon">
                                            <img src="/img/index/smallicon.svg">
                                        </div>
                                        <p>V&nbsp;průběhu soutěže dále
                                        rozdáme <span class="semibold">25&nbsp;000 poukazů</span>
                                        na čepované pivo v&nbsp;celkové
                                        hodnotě 1 mil. Kč.</p>
                                    </div>
                                    <div class="prices__image">
                                        <img src="/img/index/price3.jpg">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </section>
        <section class="howtostart" id="jak-zacit">
            <v-container>
                <v-row>
                    <v-col cols="14" offset="1" sm="16" offset-sm="0">
                        <h2 class="section-subtitle">Jak začít?</h2>
                        <div class="howtostart__boxes">
                            <div class="howtostart__box">
                                <img src="/img/index/Registration.svg" width="56px" height="60px">
                                <h3 class="section-smalltitle">Zadej svou přezdívku</h3>
                            </div>
                            <div class="howtostart__box">
                                <img src="/img/index/Teams.svg" width="56px" height="60px">
                                <h3 class="section-smalltitle">Založ si tým</h3>
                            </div>
                            <div class="howtostart__box">
                                <img src="/img/index/Ready.svg" width="56px" height="60px">
                                <h3 class="section-smalltitle">Sbírej body</h3>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </section>
        <section class="basic-rules" id="pravidla">
            <v-container>
                <h2 class="section-subtitle">Základní pravidla</h2>
                <v-row>
                    <v-col cols="14" offset="1" md="12" offset-md="3">
                        <v-row>
                            <v-col cols="16" sm="7">
                                <p class="basic-rules__rule"><span class="basic-rules__step">01</span>Zakoupené čepované pivo Staropramen
                                    ve vybrané hospodě = <span class="semibold">jeden bod</span>.</p>
                            </v-col>
                            <v-col cols="16" sm="7" offset-sm="1">
                                <p class="basic-rules__rule"><span class="basic-rules__step">02</span>Hráč může zaznamenat
                                    maximálně <span class="semibold">jeden bod denně.</span></p>
                            </v-col>
                            <v-col cols="16" sm="7">
                                <p class="basic-rules__rule"><span class="basic-rules__step">03</span>V rámci kalendářního týdne může hráč
                                    zaznamenat <span class="semibold">maximálně čtyři body.</span></p>
                            </v-col>
                            <v-col cols="16" sm="7" offset-sm="1">
                                <p class="basic-rules__rule"><span class="basic-rules__step">04</span>V jednom týmu může být
                                    <span class="semibold">maximálně pět hráčů.</span></p>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="16">
                                <p class="basic-rules__rule basic-rules__rule--detail"><span class="basic-rules__step basic-rules__step--image"></span><span>Detailní pravidla této spotřebitelské soutěže jsou k dispozici <router-link :to="{ name: 'rules' }" class="basic-rules__link" >zde</router-link></span></p>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-container>
        </section>
        <div id="coolticket-app"></div>
        <cta-block></cta-block>
        <section class="pub-map" id="mapa-hospod">
            <v-container>
                <h2 class="section-subtitle">Mapa hospod</h2>
                <v-row>
                    <v-col cols="14" offset="1" sm="10" offset-sm="3">
                        <p class="pub-map__description">Hrajeme ve více než 1&nbsp;500 hospodách v ČR, které jsou na mapě. Pro evidenci bodů
                        je potřeba mobilní aplikace <router-link style="cursor: pointer" :to="{ name: 'home', hash: '#coolticket-app' }">BeerSport</router-link>, která ti napoví, do které hospody zajít.</p>
                    </v-col>
                    <v-col cols="16" md="16" offset-md="0" offset="0">
                        <map-block></map-block>
                    </v-col>
                </v-row>
            </v-container>
        </section>
        <section class="registration">
            <v-container>
                <v-row>
                    <v-col cols="14" offset="1">
                        <v-row>
                            <v-col cols="14" offset="1" sm="8" offset-sm="0">
                                <h2>Zaregistruj se do hry</h2>
                                <p>Zvol si svou přezdívku a jdeme na to</p>
                                <v-btn
                                    color="primary"
                                    large
                                    text
                                    :to="{ name: 'registration' }"
                                >Registrovat se</v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-container>
        </section>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import HeadbarBlock from '../components/Graphics/HeadbarBlock.vue'
    import CtaBlock from '../components/Graphics/CtaBlock.vue'
    import MapBlock from '../components/Map/MapBlock.vue'

    export default {
        components: {
             HeadbarBlock,
             CtaBlock,
             MapBlock,
        },
        computed: {
            ...mapState ({
                user: state => state.user.user,
            }),
            isLoggedIn () {
                return this.$store.getters['user/isLoggedIn'];
            },
        },
    }
</script>
